import React from 'react';
import { observer } from 'mobx-react';

import { Button } from 'components/Button';

import CustomTextInputField from 'components/SharedFormComponents/CustomTextInputField';
import { useStore } from 'utils/hooks/store';
import CustomModal from 'components/CustomModal';

import CustomDatePicker from '../CustomDatePicker';
import { DetailsRowContainer, StyledContainer, TitleText } from './styles';
import CustomUserDropdownField from '../CustomUserDropdownField';

const AddActionModal: React.FunctionComponent<{
  onClose: (created: boolean) => void;
}> = ({ onClose }): React.ReactElement => {
  const { taskDetails } = useStore();

  const [name, setName] = React.useState('');
  const [assigned, setAssigned] = React.useState('');
  const [dueDate, setDueDate] = React.useState('');
  const [disableCreate, setDisableCreate] = React.useState(false);

  const handleCreate = async (): Promise<void> => {
    setDisableCreate(true);
    const result = taskDetails.createTask(name, assigned, dueDate || null);
    if (await result) {
      onClose(true);
      setDisableCreate(false);
    }
  };

  return (
    <CustomModal
      openModal
      onClose={() => onClose(false)}
      modalTitle="Create New Task"
      cancelButton={
        <Button
          id="cancel-button"
          onClick={() => onClose(false)}
          variant="outlined"
          size="large"
          data-testid="cancelButton"
        >
          Cancel
        </Button>
      }
      submitButton={
        <Button
          id="create-action-button"
          onClick={handleCreate}
          disabled={name === '' || disableCreate}
          variant="contained"
          size="large"
          data-testid="addButton"
        >
          Create Task
        </Button>
      }
    >
      <DetailsRowContainer>
        <TitleText>Task Name</TitleText>
        <CustomTextInputField
          value={name}
          onChange={(e) => setName(e as unknown as string)}
          description="Enter task name"
        />
      </DetailsRowContainer>

      <StyledContainer>
        <DetailsRowContainer>
          <TitleText>Assignee</TitleText>
          <CustomUserDropdownField
            value={assigned}
            onChange={(value) => {
              setAssigned(value ? value.uuid : '');
            }}
            description="Assigned To"
          />
        </DetailsRowContainer>

        <DetailsRowContainer>
          <TitleText>Due Date</TitleText>
          <CustomDatePicker
            tzFree
            value={dueDate || undefined}
            onChange={(val) => setDueDate((val as string | null) ?? '')}
            description=""
            size="medium"
          />
        </DetailsRowContainer>
      </StyledContainer>
    </CustomModal>
  );
};

export default observer(AddActionModal);
